import { FC } from 'react';
import { Info } from 'react-feather';
import { Typography, Grid, Box } from '@mui/material';

import styles from './TitleWithInfoIcon.module.css';

interface TitleWithInfoIconProps {
  title: string;
  cornerTitle?: string;
}

const TitleWithInfoIcon: FC<TitleWithInfoIconProps> = ({ title, cornerTitle }) => {
  return (
    <Grid
      container
      direction={{ sm: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems={{ sm: 'flex-start', md: 'center' }}
      gap={3}
      mb={3}
    >
      <span className={styles.title}>{title}</span>
      {cornerTitle != null && cornerTitle !== '' && (
        <Box display="flex" justifyContent="center" alignItems="center" gap={0.75}>
          <Info color="#266DCC" />
          <Typography fontWeight="400" fontSize="14px">
            {cornerTitle}
          </Typography>
        </Box>
      )}
    </Grid>
  );
};

export default TitleWithInfoIcon;
